import React from 'react';
import styles from './starInstruction.module.scss';
import ismobilejs from 'ismobilejs';
import LStarInstruction from '../../../components/lStarInstruction/lStarInstruction';

const isMobileJs = ismobilejs();
// isMobileJs.tablet
const isMobile = isMobileJs.any;

class StarInstruction extends React.Component {
  imgRef = React.createRef();
  isLandscape = window.matchMedia("(orientation: landscape)").matches;
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  componentDidMount() {
    document.title = '星星获取规则';
  }
  render() {
    return (
      <div style={{ position: 'relative', width: '100%', height: '100%'}}>
        {
          (isMobileJs.apple.tablet || (isMobileJs.tablet && this.isLandscape)) ?
            <div className={styles.mStarInstruction}>
              <LStarInstruction />
            </div>
            : (
              <>
                <img ref={this.imgRef} className={styles.mobileBg} src={require('../../../assets/img/instruction/rb_timetable_img_starguide_a@2x.png')} />
                <div className={styles.contentCon}>
                  <div className={styles.top} style={{ position: 'relative', marginBottom: '62px' }}>
                    <p className={`${styles.highColor} ${styles.title}`}>兑换机制？</p>
                    <p className={`${styles.darkColor} ${styles.subTitle}`}>累计100颗星星可兑换1个水晶球</p>
                    <p className={`${styles.darkColor} ${styles.subTitle}`}>每个星星罐最多可以存储20个同颜色的水晶球</p>
                    <p className={`${styles.darkColor} ${styles.subTitle}`}>超过20个水晶星球后会自动点亮下一个星星罐</p>
                  </div>

                  <div className={styles.bottom} style={{ position: 'relative' }}>
                    <p className={`${styles.highColor} ${styles.title}`}>如何获取星星？</p>
                    <p className={`${styles.highColor}`}>• 互动题答题正确</p>
                    <p className={`${styles.darkColor} ${styles.subTitle}`}>积极回答老师在课中发送的答题卡，答对就有机会获取星星哟～</p>
                    <p className={`${styles.highColor}`}>• 课堂积极表现</p>
                    <p className={`${styles.darkColor}`}>课中积极互动，就有机会被主讲/助教老师奖励小星星哟～</p>
                  </div>
                </div>
              </>
            )
        }
      </div>
    )
  }
}
export default StarInstruction;